import { render, staticRenderFns } from "./LensReportHeader.vue?vue&type=template&id=72d2162a&scoped=true"
import script from "./LensReportHeader.vue?vue&type=script&lang=js"
export * from "./LensReportHeader.vue?vue&type=script&lang=js"
import style0 from "./LensReportHeader.vue?vue&type=style&index=0&id=72d2162a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2162a",
  null
  
)

export default component.exports